'use client';

import { useDraftModeEnvironment } from 'next-sanity/hooks';

export function DisableDraftModeButton() {
  const environment = useDraftModeEnvironment();

  // Only show the disable draft mode button when outside of Presentation Tool
  if (
    environment !== 'live' &&
    environment !== 'unknown' &&
    environment !== 'checking'
  ) {
    return null;
  }

  return (
    <div className="-translate-x-1/2 fixed bottom-0 left-1/2 z-50 mb-4 flex justify-center gap-2 rounded-full border border-brand-white bg-black px-6 py-3 text-white">
      <span>You are in preview mode</span>
      &mdash;
      <a className="underline" href="/api/draft-mode/disable">
        Disable preview mode
      </a>
    </div>
  );
}
